export default __webpack_public_path__ + "static/media/Shatush of the Ecliptic.ea169ee6.jpg";